import { Button, Modal } from '@orbind/ui'

/**
 * Apagar um checklist que tem linhas VINCULADAS a Itens de Trabalho
 * (SPEC-20261006-1304-excluir-item-com-filhos).
 *
 * Antes a janela dizia "o checklist e seus itens internos serão removidos" —
 * quem via WI-0639, WI-0640 e WI-0641 na lista entendia que os três iam sair. Não
 * saíam: o checklist levava só as linhas, e os itens continuavam existindo,
 * agora fora de qualquer checklist e sem ninguém avisado.
 *
 * A janela lista os itens e deixa a pessoa decidir: eles ficam, ou vão junto.
 * Se os itens têm filhos, a escolha de levá-los aparece separada — é o número
 * que muda a decisão, e ele não está à vista na tela.
 */
export function ExcluirChecklistModal({
  nome,
  itens,
  filhos,
  excluindo,
  onManter,
  onExcluir,
  onFechar,
}: {
  nome: string
  itens: readonly { id: string; code: string; title: string }[]
  /** Quantos itens existem ABAIXO dos vinculados, somados. */
  filhos: number
  excluindo: boolean
  onManter: () => void
  onExcluir: (comFilhos: boolean) => void
  onFechar: () => void
}) {
  const n = itens.length
  return (
    <Modal
      open
      onClose={onFechar}
      title={`Excluir o checklist "${nome}"`}
      footer={
        <>
          <Button variant="ghost" onClick={onFechar} disabled={excluindo}>
            Cancelar
          </Button>
          <Button variant="secondary" onClick={onManter} disabled={excluindo}>
            Só o checklist
          </Button>
          <Button variant="danger" onClick={() => onExcluir(false)} disabled={excluindo}>
            {n === 1 ? 'Excluir também o item' : `Excluir também os ${n} itens`}
          </Button>
          {filhos > 0 ? (
            <Button variant="danger" onClick={() => onExcluir(true)} disabled={excluindo}>
              {`… e os ${filhos} ${filhos === 1 ? 'filho' : 'filhos'} deles`}
            </Button>
          ) : null}
        </>
      }
    >
      <p style={{ fontFamily: 'var(--ob-font-body)', fontSize: 13, margin: '0 0 10px' }}>
        {n === 1 ? 'Este checklist aponta para um Item de Trabalho:' : `Este checklist aponta para ${n} Itens de Trabalho:`}
      </p>

      <ul className="wi-cascata__lista" style={{ maxHeight: 220 }}>
        {itens.map((i) => (
          <li key={i.id} className="wi-cascata__linha">
            <i className="fas fa-cube" aria-hidden />
            <span className="wi-cascata__codigo">{i.code}</span>
            <span className="wi-cascata__titulo">{i.title}</span>
          </li>
        ))}
      </ul>

      <p
        style={{
          fontFamily: 'var(--ob-font-body)',
          fontSize: 12,
          color: 'var(--ob-text-muted)',
          margin: '10px 0 0',
        }}
      >
        <strong>Só o checklist</strong> tira as linhas; os itens continuam existindo, como filhos
        deste item.{' '}
        {filhos > 0
          ? `Esses itens têm ${filhos} ${filhos === 1 ? 'item' : 'itens'} abaixo deles na árvore. `
          : ''}
        Item excluído sai das listas e dos quadros; o histórico fica.
      </p>
    </Modal>
  )
}
